import { auth } from '../firebase';

/** Dev bypass, matching the server's ALLOW_DEV_AUTH. Only meaningful on localhost. */
export const DEV_MODE =
  import.meta.env.DEV && new URLSearchParams(window.location.search).has('dev');

async function authHeaders() {
  if (DEV_MODE) return {};
  const user = auth.currentUser;
  if (!user) throw new Error('Not signed in.');
  return { Authorization: `Bearer ${await user.getIdToken()}` };
}

async function getJson(path, params) {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${path}?${query}`, { headers: await authHeaders() });

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      if (body?.error) message = body.error;
    } catch {
      // Non-JSON error body — the status line is all we have.
    }
    throw new Error(message);
  }
  return response.json();
}

/** Share-count observations, one per 10-K/10-Q. The expensive call — cache it. */
export function fetchFilings(ticker, years) {
  return getJson('/api/filings', { ticker, years });
}

/** Daily bars plus the splits needed to put filed share counts on the price's basis. */
export function fetchPrices(ticker, from) {
  return getJson('/api/prices', { ticker, from });
}

export function fetchConfig() {
  return fetch('/api/config').then((r) => r.json());
}
